import React from "react";
import PageShell from "./PageShell";
import KpiBar from "./KpiBar";

/**
 * Template C — Configuration (PDR §6.C)
 * ─────────────────────────────────────
 * Purpose : persist settings (Settings · Environment · Billing Config · Pricing views).
 * Slots   : header, callout (encryption / save-behaviour explainer),
 *           statBar (Configured / Testing / Failing / Untested),
 *           sections (2-col grid of ConfigCards).
 */
export default function TemplateConfiguration({
  header, callout, statBar, sections, testId = "tpl-configuration",
}) {
  return (
    <PageShell testId={testId}>
      {header}
      {callout}
      {statBar && (statBar.items
        ? <KpiBar items={statBar.items} cols={statBar.cols ?? 4} />
        : statBar)}
      <div className="tpl-cfg-grid" data-testid="tpl-cfg-grid">{sections}</div>
    </PageShell>
  );
}
